// Petits outils partagés par les écrans du mode école.
export const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
export const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août",
  "septembre", "octobre", "novembre", "décembre"];

export const iso = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const decaler = (j, n) => { const d = new Date(`${j}T12:00:00`); d.setDate(d.getDate() + n); return iso(d); };
export const jourLisible = (j) => {
  const d = new Date(`${j}T12:00:00`);
  return `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]}`;
};
export const dateCourte = (s) => String(s || "").slice(0, 10).split("-").reverse().join(".");
export const francs = (n) => `CHF ${Number(n || 0).toLocaleString("fr-CH", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
export const tel = (t) => `tel:${String(t || "").replace(/[^\d+]/g, "")}`;

/* Un PDF dans un nouvel onglet. La fenêtre s'ouvre AU TOUCHER (après une attente, l'iPhone
   la bloque) et affiche tout de suite « Préparation… » : un aperçu de facture recalculé
   prend jusqu'à 5 secondes, et l'écran restait blanc pendant ce temps — on croyait que
   ça ne marchait pas (Jen, 02.11.2026). Fenêtre fermée entre-temps : on n'insiste pas. */
const PAGE_ATTENTE = ({ titre, texte }) => {
  const sur = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  return `<!doctype html><html lang="fr"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>${sur(titre)}</title><style>
body{margin:0;min-height:100vh;display:grid;place-items:center;background:#F4F7FA;color:#0F1B2D;
font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;text-align:center}
.r{width:34px;height:34px;margin:0 auto 18px;border-radius:50%;border:3px solid #CFF5F7;border-top-color:#14B8C4;animation:t .8s linear infinite}
@keyframes t{to{transform:rotate(360deg)}}h1{font-size:19px;margin:0 0 6px}p{font-size:14.5px;color:#64748B;margin:0 24px;line-height:1.45}
</style></head><body><div><div class="r"></div><h1>${sur(titre)}</h1><p>${sur(texte)}</p></div></body></html>`;
};
export async function fenetrePdf(charger, attente = {}) {
  const w = window.open("", "_blank");
  try {
    w?.document.write(PAGE_ATTENTE({ titre: "Ouverture du PDF…", texte: "Quelques secondes.", ...attente }));
    w?.document.close();
  } catch { /* fenêtre d'une autre origine : elle restera simplement vide le temps du chargement */ }
  let url;
  try { url = await charger(); } catch (e) { w?.close(); throw e; }
  if (!w) window.location.href = url;          // pas de fenêtre (bloquée) : on l'ouvre ici
  else if (!w.closed) w.location.href = url;   // sinon dans la sienne, si elle est encore là
}
